import cSidebarResourceImage from './SidebarResourceImage'
export const SidebarResourceImage = cSidebarResourceImage
import cSidebarResourceInfo from './SidebarResourceInfo'
export const SidebarResourceInfo = cSidebarResourceInfo
